// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-summary-scroll-main-container::-webkit-scrollbar {
  width: 6px;
  display: block;
  margin-left: 10px;
}

.order-summary-scroll-main-container::-webkit-scrollbar-thumb {
  background-color: #fff;
  border-radius: 10px;
  border: 5px solid var(--Colors-Text-300, #5b5e5d);
}

.order-summary-scroll-main-container::-webkit-scrollbar-track {
  background-color: #fff;
}
.campaign-payment-table-row {
  margin-top: 20px !important;
  max-width: 100%;
  overflow-x: auto;
}

.order-payment-total-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  align-items: center;
}
.campaign-payment-table ::-webkit-scrollbar:vertical {
  width: 6px;
}
.product-held-text.ant-typography {
  font-family: Roboto;
  font-weight: 700;
  font-style: Bold;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #000000;
}
.product-held-brief-text {
  margin-top: 5px;
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: var(--Colors-Text-400, #3b3f3d);
}
.cancel-campaign-text {
  margin-top: 5px !important;
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: var(--Colors-Text-500, #3b3f3d);
}
.cancellation-refund-link {
  cursor: pointer;
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;
  text-decoration-skip-ink: auto;
  color: #d2042d;
}
.amp-note-store-margin-card {
  margin-top: 20px !important;
}
.campaign-payment-table {
  width: 100%;
}

.campaign-payment-table.ant-table-wrapper .ant-table {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.88);
  font-size: 14px;
  line-height: 30px !important;
  padding: 0px 10px 0px 10px;
}
.campaign-payment-table.ant-table-wrapper .ant-table-thead > tr > th {
  font-family: Roboto;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px !important;
  letter-spacing: 0%;
  color: #ffffff;
}

.campaign-payment-table.ant-table-wrapper .ant-table-tbody > tr > td {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px !important;
  line-height: 100%;
  letter-spacing: 0%;
  color: var(--Colors-Text-500, #0a0f0d);
}
.enter-amount-custom-input.ant-input-group-wrapper-outlined
  .ant-input-group-addon {
  background: black !important;
  border: 0cap solid #d9d9d9 !important;
}
.seller-approval-warning-row {
  width: 100%;
  border-radius: 5px;
  padding-top: 6px;
  padding-right: 10px;
  padding-bottom: 6px;
  padding-left: 10px;
  margin-top: 10px;
  background: #f5f5f5;
  align-items: center;
}

.custom-radio-group .ant-radio-wrapper {
  margin-right: 20px;
  font-size: 16px;
  font-weight: 500;
}

.radio-active {
  color: #000;
}
.radio-inactive {
  color: #b3b3b3;
}
.divider-order-summary.ant-divider-horizontal {
  height: 0px;
  flex-shrink: 0;
  stroke-width: 1px;
  margin: 0px !important;
  border-bottom: 1px solid #b2b2b2 !important;
}
.urban-billboard-row {
  justify-content: space-between;
  cursor: pointer;
  margin-top: 20px;
  align-items: center;
}
.products-purchase-dates {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: var(--Colors-Text-400, #3b3f3d);
  text-decoration: none;
  margin-left: 10px;
  margin-right: 10px;
}
.truncate-title-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  max-width: 65%;
}
.truncate-title-text-waiting {
  max-width: 100% !important;
}
.payment-terms-total-price {
  font-family: Roboto;
  font-weight: 450;
  font-style: SemiBold;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0%;
  color: var(--Colors-Text-500, #0a0f0d);
}
.input-warning-icon-payment {
  display: flex;
  justify-content: center;
  gap: 10px;
  align-items: center;
}
.payment-method-card {
  border-radius: 10px;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
}
.payment-meth-text {
  font-family: Roboto;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 19px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #000000;
}
.pay-by-card-container {
  background: #f5f5f5;
  border: 1px solid #d3d3d3;
  margin-top: 1rem;
  border-radius: 4px;
}
.pay-by-card-text {
  font-family: Roboto;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #000000;
}
.secure-payment-new-text.ant-typography {
  font-family: Roboto !important;
  font-weight: 400 !important;
  font-style: Regular !important;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  color: var(--Colors-Text-300, #5b5e5d);
}
.pay-by-card-inner-col {
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: flex-start;
}
.payment-cards-with-icons-row {
  padding: 20px;
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: space-between;
  align-items: center;
}
.pay-by-card-diver {
  height: 0px;
  opacity: 1;
  top: 75px;
  left: 22px;
  border-width: 1px;
  border: 1px solid #d3d3d3;
  margin: 10px 0px !important;
}
.custom-stripe-form {
  width: 100%;
}

.stripe-input {
  padding: 10px;
  font-size: 14px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 6px;
  width: 100%;
}
.stripe-input-cvv {
  font-size: 14px;
  background: white;
  width: 100%;
}
.card-element-number-row {
  width: 100%;
  margin-top: 20px;
}
.common-card-fields-row {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.card-name-new-col {
  width: 42%;
}
.card-expiry-new-col {
  width: 35%;
}
.card-cvv-new-col {
  width: 20%;
}
.card-name-input-field {
  height: 100% !important;
  border: 1px solid #d3d3d3 !important;
  background: white !important;
  width: 100% !important;
}
.card-name-input-field.ant-input-filled:hover {
  background: white !important;
}
.card-name-input-field::placeholder {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  color: var(--Colors-Text-300, #999);
}
.card-name-input-field.ant-input {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  color: var(--Colors-Text-300, #999);
}
.custom-form-item-height .ant-form-item-control-input-content {
  height: 40px !important;
}

.cvc-input-with-icon {
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 10px;
  background-color: #fff;
}

.stripe-cvc-element {
  flex: 1 1;
}

.cvv-icon {
  margin-left: 10px;
  font-size: 25px;
  color: black !important;
  width: 20px !important;
  height: 17px !important;
  cursor: pointer;
}
.mandatory-check-row {
  width: 100%;
  margin-top: 20px;
  gap: 10px;
}
.proceeding-check-text {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: center;
  color: #000000;
}
.our-payment-link-text {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 14px;
  letter-spacing: 0%;
  text-align: center;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;
  text-decoration-skip-ink: auto;
  color: #d2042d;
  cursor: pointer;
}
.our-payment-link-mail {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px !important;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: center;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;
  text-decoration-skip-ink: auto;
  color: #d2042d;
  cursor: pointer;
}

.our-payment-link-mail:hover {
  color: #d2042d !important;
}

.our-payment-link-mail,
.our-payment-link-mail:visited,
.our-payment-link-mail:active,
.our-payment-link-mail:focus-visible {
  color: #d2042d !important;
  outline: none !important;
  text-decoration: underline;
}

.terms-policy-check-box.ant-checkbox .ant-checkbox-inner {
  width: 24px !important;
  height: 24px !important;
}
.terms-policy-check-box.ant-checkbox .ant-checkbox-inner:after {
  width: 7.714286px !important;
  height: 14.142857px !important;
}
.important-information-card {
  border-radius: 10px;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
  margin-top: 20px;
}

.important-information {
  font-family: Roboto;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 19px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #000000;
}
.important-information-paragraph-row {
  margin-top: 20px;
}
.important-information-paragraph-text {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: var(--Colors-Text-400, #3b3f3d);
}
.only-upfront-charged-row {
  height: 35;
  top: 254px;
  left: 31px;
  opacity: 1;
  gap: 8px;
  border-radius: 5px;
  padding: 8px;
  background: #ffebef;
  justify-content: center;
  margin-top: 20px;
}
.only-upfront-charged-text {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  color: var(--Colors-Primary-500, #d2042d);
}
.credit-debit-col {
  width: 40%;
}
.scheduled-payments-card {
  border-radius: 10px;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
  margin-top: 20px;
}
.terms-stripe-fee {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  color: var(--Colors-Text-300, #5b5e5d);
}
.schedule-payment-stripe-col {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
}
.custom-radio-group:hover {
  border-color: #d2042d !important;
}
.radio-inactive:hover {
  border-color: #d2042d !important;
}
.ant-radio-wrapper:hover .ant-radio-inner {
  border-color: #d2042d !important;
}
.stripe-image-footer-row {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-end;
  margin-right: 3% !important;
}
.review-secure-row
  .ant-steps-item:not(.ant-steps-item-active)
  > .ant-steps-item-container[role="button"]:hover
  .ant-steps-item-title,
.review-secure-row
  .ant-steps-item:not(.ant-steps-item-active)
  > .ant-steps-item-container[role="button"]:hover
  .ant-steps-item-subtitle,
.review-secure-row
  .ant-steps-item:not(.ant-steps-item-active)
  > .ant-steps-item-container[role="button"]:hover
  .ant-steps-item-description {
  color: #000 !important;
}
.review-secure-row
  .ant-steps-item:not(.ant-steps-item-active)
  > .ant-steps-item-container[role="button"]:hover
  .ant-steps-item-icon {
  border-color: transparent !important;
}
.review-secure-row
  .ant-steps-item:not(.ant-steps-item-active)
  > .ant-steps-item-container[role="button"]:hover
  .ant-steps-icon {
  color: black !important;
}
.review-secure-row
  .ant-steps-item.ant-steps-item-finish:not(.ant-steps-item-active)
  > .ant-steps-item-container[role="button"]:hover
  .ant-steps-icon {
  color: white !important;
  border-color: #d2042d !important;
}
.what-is-cvv-number {
  font-family: Roboto;
  font-weight: 400;
  font-style: SemiBold;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #000000;
}
.three-digit-code-text {
  color: var(--Colors-Text-300, #5b5e5d);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.what-is-cvv-number-row {
  display: flex;
  flex-flow: row wrap;
  min-width: 0;
  flex-direction: column;
  gap: 10px;
}
.have-american-card-row {
  display: flex;
  flex-flow: row wrap;
  min-width: 0;
  gap: 10px;
  margin-top: 20px;
}
.disabled-opacity {
  opacity: 0.5;
  pointer-events: none;
}
.disable-opacity {
  pointer-events: none;
}
.page-disabled {
  opacity: 0.5;
  pointer-events: none;
}
.custom-american-image :where(.ant-image) {
  position: relative;
  display: flex;
  justify-content: center;
}
.american-card-image.ant-row {
  width: 100%;
  justify-content: center;
}
.american-card-image .ant-image {
  position: relative;
  display: flex;
  justify-content: center;
  width: 50% !important;
}
.input-warning-icon-payment {
  display: flex;
  align-items: center;
  gap: 10px;
}

.input-warning-icon-payment svg {
  width: 16px;
  height: 15px;
}

.input-warning-icon-placeholder {
  width: 16px;
  height: 15px;
}
.products-purchase-dates-row {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 15px;
}
.product-held-row {
  display: flex;
  flex-direction: column;
}
.campaign-payment-main-container {
  /* max-height: 68vh !important;
  overflow-y: auto; */
  margin-top: 20px;
}

@media screen and (min-width: 1024px) and (max-width: 1440px) {
  .fixed-top-row {
    position: fixed;
  }
  .campaign-payment-main-container {
    max-height: 550px !important;
    overflow-y: auto !important;
  }
  .stripe-image-footer-row {
    margin-bottom: 10px !important;
  }
}
@media (min-width: 1024px) and (max-width: 1240px) {
  .medium-screen-footer-note-card {
    display: flex;
    justify-content: space-around;
    padding: 0px 15px;
    margin-top: 20px !important;
  }
  .amp-note-store-card {
    margin-top: 0px !important;
    width: 30% !important;
  }
  .card-summary-card {
    width: 100% !important;
  }
  .mandatory-check-row {
    width: 100%;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
  }
  .terms-policy-check-col {
    width: 2% !important;
  }
  .proceeding-check-text-col {
    width: 95% !important;
  }
}

@media (min-width: 1241px) and (max-width: 1599px) {
  .amp-note-store-card {
    margin-top: 0px !important;
    width: 31% !important;
  }
  .medium-screen-footer-note-card {
    display: flex;
    justify-content: center;
    padding: 0px 15px;
    margin: 20px !important;
    gap: 20px;
  }
  .card-summary-card {
    width: 100% !important;
  }
}

@media (min-width: 769px) and (max-width: 1023px) {
  .medium-screen-footer-note-card {
    display: flex;
    justify-content: center;
    gap: 20px;
    align-items: center;
    align-content: center;
  }
  .amp-note-store-card {
    width: 30% !important;
  }
  .amp-note-store-margin-card {
    margin-top: 20px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/BuyerFlow/payments-pages/RevampCampaignPayment.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,0BAA0B;EAC1B,eAAe;EACf,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;;EAEE,4BAA4B;EAC5B,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,2CAA2C;AAC7C;AACA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kDAAkD;AACpD;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,UAAU;EACV,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;EACzB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,UAAU;EACV,UAAU;EACV,UAAU;EACV,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kDAAkD;EAClD,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;;;;;;;;;;;;EAYE,sBAAsB;AACxB;AACA;;;;EAIE,oCAAoC;AACtC;AACA;;;;EAIE,uBAAuB;AACzB;AACA;;;;EAIE,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE;qBACmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,aAAa;IACb,6BAA6B;IAC7B,iBAAiB;IACjB,2BAA2B;EAC7B;EACA;IACE,0BAA0B;IAC1B,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".order-summary-scroll-main-container::-webkit-scrollbar {\n  width: 6px;\n  display: block;\n  margin-left: 10px;\n}\n\n.order-summary-scroll-main-container::-webkit-scrollbar-thumb {\n  background-color: #fff;\n  border-radius: 10px;\n  border: 5px solid var(--Colors-Text-300, #5b5e5d);\n}\n\n.order-summary-scroll-main-container::-webkit-scrollbar-track {\n  background-color: #fff;\n}\n.campaign-payment-table-row {\n  margin-top: 20px !important;\n  max-width: 100%;\n  overflow-x: auto;\n}\n\n.order-payment-total-row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  align-items: center;\n}\n.campaign-payment-table ::-webkit-scrollbar:vertical {\n  width: 6px;\n}\n.product-held-text.ant-typography {\n  font-family: Roboto;\n  font-weight: 700;\n  font-style: Bold;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: #000000;\n}\n.product-held-brief-text {\n  margin-top: 5px;\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: var(--Colors-Text-400, #3b3f3d);\n}\n.cancel-campaign-text {\n  margin-top: 5px !important;\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: var(--Colors-Text-500, #3b3f3d);\n}\n.cancellation-refund-link {\n  cursor: pointer;\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  text-decoration: underline;\n  text-decoration-style: solid;\n  text-decoration-thickness: 0%;\n  text-decoration-skip-ink: auto;\n  color: #d2042d;\n}\n.amp-note-store-margin-card {\n  margin-top: 20px !important;\n}\n.campaign-payment-table {\n  width: 100%;\n}\n\n.campaign-payment-table.ant-table-wrapper .ant-table {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: rgba(0, 0, 0, 0.88);\n  font-size: 14px;\n  line-height: 30px !important;\n  padding: 0px 10px 0px 10px;\n}\n.campaign-payment-table.ant-table-wrapper .ant-table-thead > tr > th {\n  font-family: Roboto;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 16px !important;\n  letter-spacing: 0%;\n  color: #ffffff;\n}\n\n.campaign-payment-table.ant-table-wrapper .ant-table-tbody > tr > td {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 16px !important;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: var(--Colors-Text-500, #0a0f0d);\n}\n.enter-amount-custom-input.ant-input-group-wrapper-outlined\n  .ant-input-group-addon {\n  background: black !important;\n  border: 0cap solid #d9d9d9 !important;\n}\n.seller-approval-warning-row {\n  width: 100%;\n  border-radius: 5px;\n  padding-top: 6px;\n  padding-right: 10px;\n  padding-bottom: 6px;\n  padding-left: 10px;\n  margin-top: 10px;\n  background: #f5f5f5;\n  align-items: center;\n}\n\n.custom-radio-group .ant-radio-wrapper {\n  margin-right: 20px;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.radio-active {\n  color: #000;\n}\n.radio-inactive {\n  color: #b3b3b3;\n}\n.divider-order-summary.ant-divider-horizontal {\n  height: 0px;\n  flex-shrink: 0;\n  stroke-width: 1px;\n  margin: 0px !important;\n  border-bottom: 1px solid #b2b2b2 !important;\n}\n.urban-billboard-row {\n  justify-content: space-between;\n  cursor: pointer;\n  margin-top: 20px;\n  align-items: center;\n}\n.products-purchase-dates {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: var(--Colors-Text-400, #3b3f3d);\n  text-decoration: none;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n.truncate-title-text {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  vertical-align: middle;\n  max-width: 65%;\n}\n.truncate-title-text-waiting {\n  max-width: 100% !important;\n}\n.payment-terms-total-price {\n  font-family: Roboto;\n  font-weight: 450;\n  font-style: SemiBold;\n  font-size: 18px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: var(--Colors-Text-500, #0a0f0d);\n}\n.input-warning-icon-payment {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  align-items: center;\n}\n.payment-method-card {\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n}\n.payment-meth-text {\n  font-family: Roboto;\n  font-weight: 600;\n  font-style: SemiBold;\n  font-size: 19px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: #000000;\n}\n.pay-by-card-container {\n  background: #f5f5f5;\n  border: 1px solid #d3d3d3;\n  margin-top: 1rem;\n  border-radius: 4px;\n}\n.pay-by-card-text {\n  font-family: Roboto;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: #000000;\n}\n.secure-payment-new-text.ant-typography {\n  font-family: Roboto !important;\n  font-weight: 400 !important;\n  font-style: Regular !important;\n  font-size: 14px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: var(--Colors-Text-300, #5b5e5d);\n}\n.pay-by-card-inner-col {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  align-items: flex-start;\n}\n.payment-cards-with-icons-row {\n  padding: 20px;\n  display: flex;\n  flex-direction: row;\n  align-content: center;\n  justify-content: space-between;\n  align-items: center;\n}\n.pay-by-card-diver {\n  height: 0px;\n  opacity: 1;\n  top: 75px;\n  left: 22px;\n  border-width: 1px;\n  border: 1px solid #d3d3d3;\n  margin: 10px 0px !important;\n}\n.custom-stripe-form {\n  width: 100%;\n}\n\n.stripe-input {\n  padding: 10px;\n  font-size: 14px;\n  background: white;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  width: 100%;\n}\n.stripe-input-cvv {\n  font-size: 14px;\n  background: white;\n  width: 100%;\n}\n.card-element-number-row {\n  width: 100%;\n  margin-top: 20px;\n}\n.common-card-fields-row {\n  margin-top: 20px;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n.card-name-new-col {\n  width: 42%;\n}\n.card-expiry-new-col {\n  width: 35%;\n}\n.card-cvv-new-col {\n  width: 20%;\n}\n.card-name-input-field {\n  height: 100% !important;\n  border: 1px solid #d3d3d3 !important;\n  background: white !important;\n  width: 100% !important;\n}\n.card-name-input-field.ant-input-filled:hover {\n  background: white !important;\n}\n.card-name-input-field::placeholder {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: var(--Colors-Text-300, #999);\n}\n.card-name-input-field.ant-input {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: var(--Colors-Text-300, #999);\n}\n.custom-form-item-height .ant-form-item-control-input-content {\n  height: 40px !important;\n}\n\n.cvc-input-with-icon {\n  display: flex;\n  align-items: center;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  padding: 10px;\n  background-color: #fff;\n}\n\n.stripe-cvc-element {\n  flex: 1;\n}\n\n.cvv-icon {\n  margin-left: 10px;\n  font-size: 25px;\n  color: black !important;\n  width: 20px !important;\n  height: 17px !important;\n  cursor: pointer;\n}\n.mandatory-check-row {\n  width: 100%;\n  margin-top: 20px;\n  gap: 10px;\n}\n.proceeding-check-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  text-align: center;\n  color: #000000;\n}\n.our-payment-link-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 16px;\n  line-height: 14px;\n  letter-spacing: 0%;\n  text-align: center;\n  text-decoration: underline;\n  text-decoration-style: solid;\n  text-decoration-thickness: 0%;\n  text-decoration-skip-ink: auto;\n  color: #d2042d;\n  cursor: pointer;\n}\n.our-payment-link-mail {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 16px !important;\n  line-height: 24px;\n  letter-spacing: 0%;\n  text-align: center;\n  text-decoration: underline;\n  text-decoration-style: solid;\n  text-decoration-thickness: 0%;\n  text-decoration-skip-ink: auto;\n  color: #d2042d;\n  cursor: pointer;\n}\n\n.our-payment-link-mail:hover {\n  color: #d2042d !important;\n}\n\n.our-payment-link-mail,\n.our-payment-link-mail:visited,\n.our-payment-link-mail:active,\n.our-payment-link-mail:focus-visible {\n  color: #d2042d !important;\n  outline: none !important;\n  text-decoration: underline;\n}\n\n.terms-policy-check-box.ant-checkbox .ant-checkbox-inner {\n  width: 24px !important;\n  height: 24px !important;\n}\n.terms-policy-check-box.ant-checkbox .ant-checkbox-inner:after {\n  width: 7.714286px !important;\n  height: 14.142857px !important;\n}\n.important-information-card {\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n  margin-top: 20px;\n}\n\n.important-information {\n  font-family: Roboto;\n  font-weight: 600;\n  font-style: SemiBold;\n  font-size: 19px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: #000000;\n}\n.important-information-paragraph-row {\n  margin-top: 20px;\n}\n.important-information-paragraph-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: var(--Colors-Text-400, #3b3f3d);\n}\n.only-upfront-charged-row {\n  height: 35;\n  top: 254px;\n  left: 31px;\n  opacity: 1;\n  gap: 8px;\n  border-radius: 5px;\n  padding: 8px;\n  background: #ffebef;\n  justify-content: center;\n  margin-top: 20px;\n}\n.only-upfront-charged-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: var(--Colors-Primary-500, #d2042d);\n}\n.credit-debit-col {\n  width: 40%;\n}\n.scheduled-payments-card {\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n  margin-top: 20px;\n}\n.terms-stripe-fee {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 14px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: var(--Colors-Text-300, #5b5e5d);\n}\n.schedule-payment-stripe-col {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 10px;\n}\n.custom-radio-group:hover {\n  border-color: #d2042d !important;\n}\n.radio-inactive:hover {\n  border-color: #d2042d !important;\n}\n.ant-radio-wrapper:hover .ant-radio-inner {\n  border-color: #d2042d !important;\n}\n.stripe-image-footer-row {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: flex-end;\n  margin-right: 3% !important;\n}\n.review-secure-row\n  .ant-steps-item:not(.ant-steps-item-active)\n  > .ant-steps-item-container[role=\"button\"]:hover\n  .ant-steps-item-title,\n.review-secure-row\n  .ant-steps-item:not(.ant-steps-item-active)\n  > .ant-steps-item-container[role=\"button\"]:hover\n  .ant-steps-item-subtitle,\n.review-secure-row\n  .ant-steps-item:not(.ant-steps-item-active)\n  > .ant-steps-item-container[role=\"button\"]:hover\n  .ant-steps-item-description {\n  color: #000 !important;\n}\n.review-secure-row\n  .ant-steps-item:not(.ant-steps-item-active)\n  > .ant-steps-item-container[role=\"button\"]:hover\n  .ant-steps-item-icon {\n  border-color: transparent !important;\n}\n.review-secure-row\n  .ant-steps-item:not(.ant-steps-item-active)\n  > .ant-steps-item-container[role=\"button\"]:hover\n  .ant-steps-icon {\n  color: black !important;\n}\n.review-secure-row\n  .ant-steps-item.ant-steps-item-finish:not(.ant-steps-item-active)\n  > .ant-steps-item-container[role=\"button\"]:hover\n  .ant-steps-icon {\n  color: white !important;\n  border-color: #d2042d !important;\n}\n.what-is-cvv-number {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: SemiBold;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: #000000;\n}\n.three-digit-code-text {\n  color: var(--Colors-Text-300, #5b5e5d);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.what-is-cvv-number-row {\n  display: flex;\n  flex-flow: row wrap;\n  min-width: 0;\n  flex-direction: column;\n  gap: 10px;\n}\n.have-american-card-row {\n  display: flex;\n  flex-flow: row wrap;\n  min-width: 0;\n  gap: 10px;\n  margin-top: 20px;\n}\n.disabled-opacity {\n  opacity: 0.5;\n  pointer-events: none;\n}\n.disable-opacity {\n  pointer-events: none;\n}\n.page-disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n.custom-american-image :where(.ant-image) {\n  position: relative;\n  display: flex;\n  justify-content: center;\n}\n.american-card-image.ant-row {\n  width: 100%;\n  justify-content: center;\n}\n.american-card-image .ant-image {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  width: 50% !important;\n}\n.input-warning-icon-payment {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.input-warning-icon-payment svg {\n  width: 16px;\n  height: 15px;\n}\n\n.input-warning-icon-placeholder {\n  width: 16px;\n  height: 15px;\n}\n.products-purchase-dates-row {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-top: 15px;\n}\n.product-held-row {\n  display: flex;\n  flex-direction: column;\n}\n.campaign-payment-main-container {\n  /* max-height: 68vh !important;\n  overflow-y: auto; */\n  margin-top: 20px;\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1440px) {\n  .fixed-top-row {\n    position: fixed;\n  }\n  .campaign-payment-main-container {\n    max-height: 550px !important;\n    overflow-y: auto !important;\n  }\n  .stripe-image-footer-row {\n    margin-bottom: 10px !important;\n  }\n}\n@media (min-width: 1024px) and (max-width: 1240px) {\n  .medium-screen-footer-note-card {\n    display: flex;\n    justify-content: space-around;\n    padding: 0px 15px;\n    margin-top: 20px !important;\n  }\n  .amp-note-store-card {\n    margin-top: 0px !important;\n    width: 30% !important;\n  }\n  .card-summary-card {\n    width: 100% !important;\n  }\n  .mandatory-check-row {\n    width: 100%;\n    margin-top: 20px;\n    display: flex;\n    justify-content: space-between;\n  }\n  .terms-policy-check-col {\n    width: 2% !important;\n  }\n  .proceeding-check-text-col {\n    width: 95% !important;\n  }\n}\n\n@media (min-width: 1241px) and (max-width: 1599px) {\n  .amp-note-store-card {\n    margin-top: 0px !important;\n    width: 31% !important;\n  }\n  .medium-screen-footer-note-card {\n    display: flex;\n    justify-content: center;\n    padding: 0px 15px;\n    margin: 20px !important;\n    gap: 20px;\n  }\n  .card-summary-card {\n    width: 100% !important;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 1023px) {\n  .medium-screen-footer-note-card {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    align-items: center;\n    align-content: center;\n  }\n  .amp-note-store-card {\n    width: 30% !important;\n  }\n  .amp-note-store-margin-card {\n    margin-top: 20px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
